import { ReactNode, useEffect, useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import { Box, Button, Typography, useTheme } from '@mui/joy';
import { Image } from '@mui/icons-material';
import { useYear } from '../../providers/YearProvider';
//import { removeHtmlTags } from '../../lib/utils';

interface IProps {
	component: ReactNode;
	title: string | ReactNode;
	page: string;
}

const ImageExportUtility = ({ component, title, page }: IProps) => {
	const theme = useTheme();
	const exportRef = useRef<HTMLDivElement>(null);
	const [download, setDownload] = useState(false);
	const { year } = useYear();

	const onDownloadClick = () => {
		setDownload(true);
	};

	const cleanTitle = 'chart';
	const source =
		page === 'state' || page === 'national'
			? 'Source: CAWP and OpenSecrets'
			: 'Source: CAWP, OpenSecrets, and Catalist';

	const options: { [x: string]: string } = {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	};
	const date = new Date().toLocaleDateString(undefined, options);

	useEffect(() => {
		if (download) {
			setTimeout(() => {
				if (exportRef.current !== null) {
					 
					html2canvas(exportRef.current, { scale: 1 }).then(
						(canvas: HTMLCanvasElement) => {
							const a = document.createElement('a');
							a.href = canvas
								.toDataURL('image/png')
								.replace('image/jpeg', 'image/octet-stream');
							a.download = `${cleanTitle}.png`;
							a.click();
							setDownload(false);
						}
					);
				}
			}, 500);
		}
	}, [download, title]);
	return (
		<>
			<Button
				onClick={onDownloadClick}
				sx={{
					backgroundColor: 'transparent',
					//paddingRight: 0,
					'&:hover': {
						backgroundColor:
							theme.colorSchemes.light.palette.chartElementsBackground.bg
					},
					'.MuiSvgIcon-root': {
						fill: theme.colorSchemes.light.palette.chartElementsBackground
							.baseLine,
						fontSize: '1.75rem'
					}
				}}
			>
				<Typography level='label' sx={{ marginRight: '.5rem' }}>
					Image
				</Typography>
				<Image />
			</Button>
			<Box
				ref={exportRef}
				aria-hidden='true'
				sx={{
					position: 'absolute',
					top: '200px',
					left: '-50000px',
					width: '1400px',
					minHeight: '650px',
					zIndex: 1000,
					padding: '2rem',
					backgroundColor: theme.colorSchemes.light.palette.background.surface
				}}
			>
				{component}
				<Box sx={{ marginTop: '1rem', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', fontSize: '1rem', gap: '0.15rem' }}>
					<span>Election {year}</span>
					<span>{source}</span>
					<span>Accessed datestamp {date}</span>
				</Box>
			</Box>
		</>
	);
};

export default ImageExportUtility;
